<template>
  <div class="bg">
    <div class="title">
      <p>国家社会科学基金资助期刊</p>
      <p>
        <!-- <img src="@/assets/images/ax.png" />
        <span @click="save">收藏本站</span> |
        <span @click="home">设为首页</span> -->
      </p>
    </div>
    <div class="cd">
      <img src="@/assets/images/cd.png" />
      <p>ECONOMIC RESEARCH JOURNAL</p>
    </div>
    <div style="text-align: center; margin-top: 90px">
      <el-input
        v-model="input1"
        style="width: 480px; height: 64px; border-radius: 8px; overflow: hidden"
        size="large"
        placeholder="本刊全文检索"
        :prefix-icon="Search"
      >
        <template #append>
          <span @click="jump2"> 搜索 </span>
        </template>
      </el-input>
    </div>
    <div @click="open" class="tg cover">在线投审稿系统</div>
    <div class="btn">
      <div @click="jump" class="hm cover">首页</div>
      <div @click="jump1" class="hmen cover">ENGLISH</div>
    </div>
    <div class="bm" @click="ba">京ICP备 10211437号</div>
  </div>
</template>

<script setup>
import { useRouter } from "vue-router";
import { Search } from "@element-plus/icons-vue";
import { ref } from "vue";
const router = useRouter();
function jump() {
  router.push({
    path: "/index",
  });
}
function jump1() {
  router.push({
    path: "/enIndex",
  });
}
let input1 = ref("");
function jump2() {
  router.push({
    path: "/search",
    query: {
      keywords: input1.value,
    },
  });
}
function open() {
  window.open("https://erj.ajcass.com/Admin/user/login/");
}

function ba() {
  // window.open("https://beian.miit.gov.cn/");
}
function addToFavorites(title, url) {
  if (window.sidebar) {
    // Mozilla Firefox bookmark
    window.sidebar.addPanel(title, url, "");
  } else if (window.external) {
    // IE Favorite
    window.external.AddFavorite && window.external.AddFavorite(url, title);
  } else if (window.opera && window.print) {
    // Opera Hotlist
    this.title = title;
    return true;
  } else {
    // webkit bookmark
    alert(
      "Press " +
        (navigator.userAgent.toLowerCase().indexOf("mac") != -1
          ? "Command/Cmd"
          : "CTRL") +
        " + D to bookmark this page"
    );
  }
}

// 使用方法：
function save() {
  addToFavorites("经济研究", location.href);
}
function home() {
  // 示例代码：将当前页面设为首页
  if (window.external && "addSearchProvider" in window.external) {
    window.external.AddSearchProvider("***");
  } else if (window.google && "addSearchProvider" in window.google) {
    window.google.addSearchProvider("***");
  }
}
</script>
<style lang="less" scoped>
.bm {
  text-align: center;
  margin-top: 40px;
  opacity: 0.765;
  font-family: PingFang SC;
  font-size: 18px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #fcfdff;
  cursor: pointer;
  height: 100px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: self-end;
}
.bg {
  min-width: 760px;
  display: flex;
  flex-direction: column;
  padding: 40px 60px 40px;
  background: url("../assets/images/bg.jpg") no-repeat;
  background-size: 100% 100%;
  min-height: 100vh;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  p:first-of-type {
    font-family: PingFang SC;
    font-size: 20px;
    line-height: 50px;
    text-align: center;
    color: #ffffff;
  }
  p:last-of-type {
    color: #fff;
    cursor: pointer;
    img {
      margin-right: 5px;
    }
  }
}
.cd {
  margin-top: 56px;
  text-align: center;
  img {
    height: 225px;
  }
  p {
    margin-top: -30px;
    font-family: PingFang SC;
    font-size: 30px;
    font-weight: 600;
    line-height: 50px;
    text-align: center;
    color: rgba(255, 255, 255, 0.6);
  }
}
::v-deep .el-input-group__append {
  padding-right: 20px;
  background-color: #fff !important;
  height: 40px;
  opacity: 1;
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #003f97;
  cursor: pointer;
}
::v-deep .el-input__wrapper {
  box-shadow: none;
}

.tg {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 16px auto;
  width: 480px;
  height: 64px;
  border-radius: 8px;
  opacity: 1;
  background: #bcd3ff;
  box-shadow: 0px 2px 10px 0px rgba(0, 18, 43, 0.3);
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  text-align: center;
  letter-spacing: 0em;
  font-variation-settings: "opsz" auto;
  color: #003f97;
  cursor: pointer;
}

.btn {
  width: 480px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  font-family: PingFang SC;
  font-size: 20px;
  font-weight: 600;
  line-height: 40px;
  text-align: center;
  letter-spacing: 0em;
  color: #003f97;
  .hm {
    width: 231px;
    height: 64px;
    border-radius: 8px;
    opacity: 1;
    /* 自动布局 */
    display: flex;
    flex-direction: column;
    padding: 12px 56px;
    background: #bcd3ff;
    box-shadow: 0px 2px 10px 0px rgba(0, 18, 43, 0.3);
    cursor: pointer;
  }
  .hmen {
    width: 231px;
    height: 64px;
    border-radius: 8px;
    opacity: 1;
    /* 自动布局 */
    display: flex;
    flex-direction: column;
    padding: 12px 56px;
    background: #bcd3ff;
    box-shadow: 0px 2px 10px 0px rgba(0, 18, 43, 0.3);
    cursor: pointer;
  }
}

::v-deep .el-input__inner {
  font-size: 20px;
}
::v-deep .el-input__icon {
  font-size: 20px;
}
::v-deep .is-focus {
  box-shadow: none !important;
}

::v-deep .el-input {
  border: none !important;
  --el-input-hover-border-color: none;
}
::v-deep .el-input:hover {
  border: none !important;
}
.cover:hover {
  background-color: #a7c4ff;
  color: #003f97;
}
</style>
